import { useState } from 'react';
import { ButtonPrimary, ButtonSecondary, ButtonSize } from '@ui/src';
import { AMLAdditionalInformationTypes } from './types';
import { CustomerStatus, OrganizationType } from '../../../hoc/common/types';
import CorporateAdditionalInformation from './parts/corporate-additional-infiormation';
import IndividualAdditionalInfo from './parts/individual-additional-info';
import AdditionalInfoWrapper from './parts/additional-info-wrapper';

import cn from './styles.module.css';

const AdditionalInformation = ({
  control,
  questionnaireFields,
  setValue,
  currentApplicationScheme,
  questionnaire,
  isDirty,
  onResetQuestionnaire,
  onUpdateQuestionnaire,
  requestInProgress,
  status,
  type,
  errors,
  clearErrors,
  relationshipToTheCustomerDictionary,
  countries,
  sourceOfWealth,
  baseCurrency,
  businessActivities,
  customerMainClients,
  salesChannels,
  customerSourceOfFunds,
  customerSourceOfWealth,
  annualIncomes,
  totalIncomeError,
  setTotalIncomeError,
  typeOfAccounts,
  accountsCurrenciesIsLoading,
  accountsCurrenciesIsFetching,
  accountsCurrenciesValues,
  setAccountsCurrenciesValues,
  currencies,
  onDeleteAccountCurrencies,
  selectedAccountsCurrencyId,
  deleteAccountsCurrenciesInProgress,
  setAccountsFlowsValues,
  accountsFlowsValues,
  accountsFlowsIsLoading,
  accountsFlowsIsFetching,
  currenciesList,
  expectedFundsOriginsIsLoading,
  expectedFundsOriginsIsFetching,
  deleteExpectedFundsOriginsInProgress,
  onDeleteExpectedFundsOrigins,
  selectedExpectedFundsOriginsId,
  expectedFundsOriginsValues,
  setExpectedFundsOriginsValues,
  createAccountsCurrenciesIsProgress,
  updateAccountsCurrenciesInProgress,
  createAccountsFlowsIsProgress,
  updateAccountsFlowsInProgress,
  createExpectedFundsOriginsInProgress,
  updateExpectedFundsOriginsInProgress,
  sourceOfIncome,
  sourceOfWealthForIndividual,
  selectedCrsAndFatcaId,
  crsAndFatcaIsLoading,
  crsAndFatcaIsFetching,
  createCrsAndFatcaIsProgress,
  updateCrsAndFatcaInProgress,
  deleteCrsAndFatcaInProgress,
  onDeleteCRSAndFatca,
  organizationControl,
  organizationErrors,
  organizationClearErrors,
  organizationFields,
  organizationSetValue,
  crsAndFatcaValues,
  setCrsAndFatcaValues,
  isCof,
  affilatedCompaniesValues,
  setAffilatedCompaniesValues,
  selectedAffilatedCompanyId,
  affilatedCompaniesIsLoading,
  affilatedCompaniesIsFetching,
  createAffilatedCompanyInProgress,
  updateAffilatedCompanyInProgress,
  deleteAffilatedCompanyInProgress,
  onDeleteAffilatedCompany,
}: AMLAdditionalInformationTypes) => {
  const [selectedFilter, setSelectedFilter] = useState<'all' | 'onlyYes'>(
    'all',
  );

  let content;

  if (type === OrganizationType.CORPORATE) {
    content = (
      <CorporateAdditionalInformation
        currentApplicationScheme={currentApplicationScheme}
        control={control}
        questionnaire={questionnaire}
        status={status}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        questionnaireFields={questionnaireFields}
        setValue={setValue}
        errors={errors}
        clearErrors={clearErrors}
        relationshipToTheCustomerDictionary={
          relationshipToTheCustomerDictionary
        }
        countries={countries}
        sourceOfWealth={sourceOfWealth}
        baseCurrency={baseCurrency}
        businessActivities={businessActivities}
        customerMainClients={customerMainClients}
        salesChannels={salesChannels}
        customerSourceOfFunds={customerSourceOfFunds}
        customerSourceOfWealth={customerSourceOfWealth}
        annualIncomes={annualIncomes}
        totalIncomeError={totalIncomeError}
        setTotalIncomeError={setTotalIncomeError}
        typeOfAccounts={typeOfAccounts}
        accountsCurrenciesIsLoading={accountsCurrenciesIsLoading}
        accountsCurrenciesIsFetching={accountsCurrenciesIsFetching}
        accountsCurrenciesValues={accountsCurrenciesValues}
        setAccountsCurrenciesValues={setAccountsCurrenciesValues}
        currencies={currencies}
        onDeleteAccountCurrencies={onDeleteAccountCurrencies}
        selectedAccountsCurrencyId={selectedAccountsCurrencyId}
        deleteAccountsCurrenciesInProgress={deleteAccountsCurrenciesInProgress}
        setAccountsFlowsValues={setAccountsFlowsValues}
        accountsFlowsValues={accountsFlowsValues}
        accountsFlowsIsLoading={accountsFlowsIsLoading}
        accountsFlowsIsFetching={accountsFlowsIsFetching}
        currenciesList={currenciesList}
        expectedFundsOriginsIsLoading={expectedFundsOriginsIsLoading}
        expectedFundsOriginsIsFetching={expectedFundsOriginsIsFetching}
        deleteExpectedFundsOriginsInProgress={
          deleteExpectedFundsOriginsInProgress
        }
        onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
        selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
        expectedFundsOriginsValues={expectedFundsOriginsValues}
        setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
        setCrsAndFatcaValues={setCrsAndFatcaValues}
        onDeleteCRSAndFatca={onDeleteCRSAndFatca}
        onDeleteAffilatedCompany={onDeleteAffilatedCompany}
        setAffilatedCompaniesValues={setAffilatedCompaniesValues}
      />
    );
  } else {
    content = (
      <IndividualAdditionalInfo
        questionnaire={questionnaire}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        currentApplicationScheme={currentApplicationScheme}
        control={control}
        status={status}
        questionnaireFields={questionnaireFields}
        setValue={setValue}
        errors={errors}
        clearErrors={clearErrors}
        countries={countries}
        baseCurrency={baseCurrency}
        accountsCurrenciesIsLoading={accountsCurrenciesIsLoading}
        accountsCurrenciesIsFetching={accountsCurrenciesIsFetching}
        accountsCurrenciesValues={accountsCurrenciesValues}
        setAccountsCurrenciesValues={setAccountsCurrenciesValues}
        currencies={currencies}
        onDeleteAccountCurrencies={onDeleteAccountCurrencies}
        selectedAccountsCurrencyId={selectedAccountsCurrencyId}
        deleteAccountsCurrenciesInProgress={deleteAccountsCurrenciesInProgress}
        setAccountsFlowsValues={setAccountsFlowsValues}
        accountsFlowsValues={accountsFlowsValues}
        accountsFlowsIsLoading={accountsFlowsIsLoading}
        accountsFlowsIsFetching={accountsFlowsIsFetching}
        currenciesList={currenciesList}
        expectedFundsOriginsIsLoading={expectedFundsOriginsIsLoading}
        expectedFundsOriginsIsFetching={expectedFundsOriginsIsFetching}
        deleteExpectedFundsOriginsInProgress={
          deleteExpectedFundsOriginsInProgress
        }
        onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
        selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
        expectedFundsOriginsValues={expectedFundsOriginsValues}
        setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
        sourceOfWealth={sourceOfWealth}
        sourceOfIncome={sourceOfIncome}
        sourceOfWealthForIndividual={sourceOfWealthForIndividual}
        customerSourceOfFunds={customerSourceOfFunds}
        selectedCrsAndFatcaId={selectedCrsAndFatcaId}
        crsAndFatcaIsLoading={crsAndFatcaIsLoading}
        crsAndFatcaIsFetching={crsAndFatcaIsFetching}
        deleteCrsAndFatcaInProgress={deleteCrsAndFatcaInProgress}
        onDeleteCRSAndFatca={onDeleteCRSAndFatca}
        organizationControl={organizationControl}
        organizationErrors={organizationErrors}
        organizationClearErrors={organizationClearErrors}
        organizationFields={organizationFields}
        organizationSetValue={organizationSetValue}
        crsAndFatcaValues={crsAndFatcaValues}
        setCrsAndFatcaValues={setCrsAndFatcaValues}
        isCof={isCof}
        affilatedCompaniesValues={affilatedCompaniesValues}
        setAffilatedCompaniesValues={setAffilatedCompaniesValues}
        selectedAffilatedCompanyId={selectedAffilatedCompanyId}
        affilatedCompaniesIsLoading={affilatedCompaniesIsLoading}
        affilatedCompaniesIsFetching={affilatedCompaniesIsFetching}
        deleteAffilatedCompanyInProgress={deleteAffilatedCompanyInProgress}
        onDeleteAffilatedCompany={onDeleteAffilatedCompany}
        setTotalIncomeError={setTotalIncomeError}
      />
    );
  }

  return (
    <AdditionalInfoWrapper>
      {content}
      {(control || organizationControl) && status !== CustomerStatus.CLOSED && (
        <div className={cn.controlsWrapper}>
          <ButtonPrimary
            size={ButtonSize.SMALL}
            text={
              requestInProgress ||
              createAccountsCurrenciesIsProgress ||
              updateAccountsCurrenciesInProgress ||
              createAccountsFlowsIsProgress ||
              updateAccountsFlowsInProgress ||
              createExpectedFundsOriginsInProgress ||
              updateExpectedFundsOriginsInProgress ||
              createCrsAndFatcaIsProgress ||
              updateCrsAndFatcaInProgress ||
              createAffilatedCompanyInProgress ||
              updateAffilatedCompanyInProgress
                ? 'Loading...'
                : 'Save'
            }
            className={cn.saveQuestionnaireButton}
            disabled={
              !isDirty ||
              requestInProgress ||
              createAccountsCurrenciesIsProgress ||
              updateAccountsCurrenciesInProgress ||
              createAccountsFlowsIsProgress ||
              updateAccountsFlowsInProgress ||
              createExpectedFundsOriginsInProgress ||
              updateExpectedFundsOriginsInProgress ||
              createCrsAndFatcaIsProgress ||
              updateCrsAndFatcaInProgress ||
              createAffilatedCompanyInProgress ||
              updateAffilatedCompanyInProgress
            }
            onClick={onUpdateQuestionnaire}
            bold
          />
          <ButtonSecondary
            className="button-white"
            size={ButtonSize.SMALL}
            text="Reset"
            disabled={
              !isDirty ||
              requestInProgress ||
              createAccountsCurrenciesIsProgress ||
              updateAccountsCurrenciesInProgress ||
              createAccountsFlowsIsProgress ||
              updateAccountsFlowsInProgress ||
              createExpectedFundsOriginsInProgress ||
              updateExpectedFundsOriginsInProgress ||
              createCrsAndFatcaIsProgress ||
              updateCrsAndFatcaInProgress
            }
            onClick={onResetQuestionnaire}
            bold
          />
        </div>
      )}
    </AdditionalInfoWrapper>
  );
};

export default AdditionalInformation;
